import { render } from "./DynamicDetails.vue?vue&type=template&id=2d2d8f3d&scoped=true"
import script from "./DynamicDetails.vue?vue&type=script&lang=js"
export * from "./DynamicDetails.vue?vue&type=script&lang=js"

import "./DynamicDetails.vue?vue&type=style&index=0&id=2d2d8f3d&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2d8f3d"]])

export default __exports__